<template>
  <div class="p-3 bg-white">
    <shared-sound-file-add
      @addSoundFileSuccess="addSoundFileSuccess"
    ></shared-sound-file-add>

    <div class="text-center">
      <vs-button id="addSoundFileButton" class="m-2" color="primary" type="filled" @click.prevent="addSoundFile">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddSoundFile">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>

import SharedSoundFileAdd from '@/views/Shared/SoundFiles/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.SoundFile.Add',
  components: {
    SharedSoundFileAdd
  },
  methods: {
    addSoundFile () {
      EventBus.$emit('initAddSoundFile')
    },
    addSoundFileSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_sound_file_table')
      window.close()
    },
    cancelAddSoundFile () {
      this.$windowOpenerHelper.notifyOpener('reload_sound_file_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
